module.exports = __webpack_public_path__ + "static/media/delete.8c32dc61.png";